import React, { Component } from "react";
import Layout from "../../components/Layout";
import Meta from "../../components/Meta";
import MenuNL from "../../components/nl/MenuNL";
import FooterNL from "../../components/nl/FooterNL";

class Index extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Layout>
                <Meta
                    title={"Anna Mamchenkova – boekhouding en  beheerscontrole"}
                    description={"Boekhoudster, expert in beheerscontrole en rentabiliteit: Anna coördineert de dossiers van bedrijven die in moeilijkheden verkeren."}
                    url={"https://www.coeladvocaten.be/nl/anna-mamchenkova"}
                    robots={"index, follow"}
                    languages={[
                        { url:"https://www.coeladvocaten.be/nl/anna-mamchenkova", language:"nl" },
                        { url:"https://www.coeladvocaten.be/fr/anna-mamchenkova", language:"fr" },
                        { url:"https://www.coeladvocaten.be/en/anna-mamchenkova", language:"en" }
                    ]}
                />

                <MenuNL
                    switchUrlFR="/fr/anna-mamchenkova"
                    switchUrlEN="/en/anna-mamchenkova"
                />

                <div className="page">
                    <div className="header">
                        <div className="grayscale background background-team"></div>
                        <div className="slider">
                            <h1>Ons team</h1>
                            <h2>Anna Mamchenkova</h2>
                            <p></p>
                            <a href="/nl/contact" alt="contact" className="button">info@coeladvocaten.be</a>
                        </div>
                    </div>

                    <div className="content">
                        <div className="container press">
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <div className="image">
                                                <img className="img-fluid grayscale team-image-opacity" src="/static/images/ons-team-anna.jpg" width="100%" height="auto" /> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <p></p>
                                            <p>Anna Mamchenkova heeft het diploma van metallurgisch ingenieur en heeft haar sterktes te danken aan haar initiële studie. Ze is een minutieus en onderzoekt alle verschillende parameters in elke situatie, voor ze een beslissing neemt.</p>
                                            <p>Wanneer Anna in België kwam wonen, studeerde ze boekhouding en beheerscontrole. Al snel neemt haar analytische aanleg de overhand en beseft ze dat haar interesse uitgaat naar boekhoudkundige instrumenten om:</p>
                                            <p>-	waardebepalingen correct uit te voeren</p>
                                            <p>-	analyses en diagnoses te stellen van de financiële en operationele gezondheid </p>
                                            <p>-	de juiste beslissingen te nemen op vlak van beheerscontrole</p>
                                            <p>Na meerdere jaren ervaring als boekhoudster en expert in beheerscontrole vervoegt ze het kabinet van Coel & Advocaten als verantwoordelijke voor de boekhouding.</p>
                                            <p>Al snel neemt Anna nieuwe verantwoordelijkheden op zich en stelt ze haar kennis in boekhouding en beheerscontrole in dienst van de cliënten van Frank Coel. Zo helpt ze bij de herstructurering of het herstelplan van bedrijven, bij de waardebepaling van een bedrijf bij een overdracht, fusie of overname, en zorgt ze voor een vlot verloop bij bedrijven die hun activiteiten stopzetten.</p>
                                            <p>Op vandaag is Anna Mamchenkova nog steeds de experte inzake boekhouding en organisatie van het advocatenkantoor. Daarnaast coördineert ze ook het advies aan bedrijven in moeilijkheden.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row"><br /></div>
                        </div>
                    </div>
                </div>

                <FooterNL />
            </Layout>
        );
    }
}

export default Index;
